export const leaveOptions = [
    { value: "Personal Leave", label: "Personal Leave" },
    { value: "Sick/Medical Leave", label: "Sick/Medical Leave" },
    { value: "Emergency Leave", label: "Emergency Leave" },
    { value: "Maternity Leave", label: "Maternity Leave" },
    { value: "Paternity Leave", label: "Paternity Leave" },
    { value: "Bereavement Leave", label: "Bereavement Leave" },
    { value: "Special Leave", label: "Special Leaves - Birthday/ Marriage Anniversary" }
];

export const DESIGNATIONS = [
    "Associate Software Engineer",
    "Business Analyst",
    "CEO",
    "CTO",
    "Data Analyst",
    "Data Engineer",
    "Data Scientist",
    "DataBase Administrator",
    "Delivery Lead",
    "DevOps Engineer",
    "Director",
    "Employee",
    "Executive Finance - HR & Admin",
    "Graduate Trainee",
    "HR Administrator",
    "HR Executive",
    "HR Manager",
    "Intern",
    "Jr. Executive - Finance, HR & Admin",
    "Junior Software Engineer",
    "Lead Software Engineer",
    "Manager",
    "ML Ops & Data Engineer",
    "Product Manager",
    "Project Lead",
    "Project Manager",
    "QA Engineer",
    "Research Analyst",
    "Research Manager",
    "Sales Director",
    "Senior Analyst",
    "Senior Business Analyst",
    "Senior Project Lead",
    "Senior QA Engineer",
    "Senior Research Analyst",
    "Senior Software Engineer",
    "Software Developer",
    "Software Engineer",
    "Solution Architect",
    "System Administrator",
    "Technical Lead",
    "Technical Project Manager",
    "UI/UX Designer"
];

export const ROLES = [
    { value: "Employee", label: "Employee" },
    { value: "GT", label: "Graduate Trainee" },
    { value: "Intern", label: "Intern" }
];

export const ADMIN_ROLES = [
    { value: "Admin", label: "Super Admin" },
    { value: "Manager", label: "Manager" },
    { value: "HR", label: "HR" }
];

export const MANAGERS = [
    { value: "venkata@data-aces.com", label: "Venkata" },
    { value: "shanti@data-aces.com", label: "Shanti" },
    { value: "naren@data-aces.com", label: "Naren" }
];

export const EVENT_TYPES = [
    { value: 'Meeting', label: 'Meeting' },
    { value: 'Training', label: 'Training' },
    { value: 'Workshop', label: 'Workshop' },
    { value: 'Client Meeting', label: 'Client Meeting' },
    { value: 'Interview', label: 'Interview' },
    { value: 'Company Event', label: 'Company Event' },
    { value: 'Team Building', label: 'Team Building' },
    { value: 'Celebration', label: 'Celebration' },
    { value: 'Birthday', label: 'Birthday' },
    { value: 'Work Anniversary', label: 'Work Anniversary' },
    { value: 'Holiday', label: 'Holiday' },
    { value: 'Other', label: 'Other' }
];

export const LOCATIONS = [
    { value: "India", label: "India" },
    { value: "US", label: "US" },
];
export const ALL_LOCATIONS = [
    { value: "India", label: "India" },
    { value: "US", label: "US" },
    { value: "Canada", label: "Canada" },
];

export const LETTER_TYPES = [
    { value: "offerLetter", label: "Offer Letter" },
    { value: "exitLetter", label: "Exit Letter" },
    { value: "internLetter", label: "Internship Completion Letter" },
    { value: "internOfferLetter", label: "Internship Offer Letter" },
    { value: "addressProofLetter", label: "Address Proof Letter" },
    { value: "provisionalOfferLetter", label: "Provisional Offer Letter" }
];

export const DEGREES = [
    { value: "BSc", label: "B.Sc" },
    { value: "BBA", label: "B.B.A" },
    { value: "BE", label: "B.E" },
    { value: "BTech", label: "B.Tech" },
    { value: "BCA", label: "B.C.A" },
    { value: "BA", label: "B.A" }
];

export const PG_DEGREES = [
    { value: "MSc", label: "M.Sc" },
    { value: "MBA", label: "M.B.A" },
    { value: "ME", label: "M.E" },
    { value: "MTech", label: "M.Tech" },
    { value: "MCA", label: "M.C.A" },
    { value: "MA", label: "M.A" }
];

export const TICKET_CATEGORIES = [
    "Leave",
    "WFH",
    "Timesheet",
    "Payroll",
    "Documents",
    "IT Support",
    "Insurance / Medical",
    "Policy Clarification",
    "General",
];
